export function formatEvidenceValue(value?: string | number | boolean | null) {
  if (value === undefined || value === null || value === '') {
    return '-';
  }

  return String(value);
}

export function formatEvidence(
  value: string | number | boolean | null | undefined,
  error?: string,
): { error?: boolean; value: string } {
  return error ? { error: true, value: error } : { value: formatEvidenceValue(value) };
}
